import "vite/modulepreload-polyfill";
import { createRoot } from "react-dom/client";
import SuggestionWidget from "../suggestions/components/SuggestionWidget/SuggestionWidget.jsx";
import ContactWidget from "../contact/Components/ContactWidget.jsx";

const container = document.getElementById("suggestions-contact-widget-container");
const configContainer = document.getElementById("suggestions-contact-widget-config");  
let configuration = "";
if (configContainer) {
  configuration = JSON.parse(configContainer.innerText);
}

if (container){
  const root = createRoot(container);
  root.render(
      <div className="suggestions_contact_widget-container">
        <ContactWidget config={configuration}/>
        <SuggestionWidget config={configuration}/>
      </div>
  );
}
